import { useMemo } from "react";

import moment from "moment";

import type { Clock } from "~/v2/api/rest/data";
import {
  OPTION_TIME_IN_FORCE_OPTIONS,
  type OptionOrderType,
  type OptionTimeInForce,
} from "~/v2/constants/optionOrder";

const EASTERN_TIMEZONE = "America/New_York";

export interface TimeInForceOption {
  label: string;
  subLabel?: string;
  value: OptionTimeInForce;
}

export const getTimeInForceOptions = (
  orderType: OptionOrderType,
  clock: Clock | undefined,
): TimeInForceOption[] =>
  OPTION_TIME_IN_FORCE_OPTIONS.filter((tif) =>
    tif.orderTypes.includes(orderType),
  ).map(({ label, subLabel, value }) => {
    if (value === "day" && clock) {
      const now = moment().tz(EASTERN_TIMEZONE);
      const nextClose = moment.tz(clock.next_close, EASTERN_TIMEZONE);

      if (clock.is_open && now.isBefore(nextClose)) {
        return {
          label,
          subLabel: `Expires at ${nextClose.format("h:mm a")} ET today`,
          value,
        };
      }
      if (!clock.is_open && now.isBefore(nextClose)) {
        return {
          label,
          subLabel: `Expires ${nextClose.format("MM/DD h:mm a")} ET`,
          value,
        };
      }
    }

    return { label, subLabel, value };
  });

export const useTimeInForceOptions = (
  orderType: OptionOrderType,
  clock: Clock | undefined,
) => {
  return useMemo(
    () => getTimeInForceOptions(orderType, clock),
    [orderType, clock],
  );
};
